// extracted by mini-css-extract-plugin
export default {"container":"StartWithUs_container__4KpOP","desc":"StartWithUs_desc__s-p0i","just-book":"StartWithUs_just-book__iXGAZ"};